module.exports = __webpack_public_path__ + "static/media/BG.e30bc5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/BG.png
// module id = 937
// module chunks = 0